import type { Label } from '@hive/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { queryKeys } from './keys';

/** Every label; filter with `labelsFor` for one game. */
export function useLabels() {
  return useQuery({
    queryKey: queryKeys.labels,
    queryFn: async (): Promise<Label[]> => {
      const { data, error } = await supabase().from('labels').select('*').order('name');
      if (error) throw error;
      return data;
    },
  });
}

/** The labels a game's tasks can use: its own and the studio-wide ones. */
export function labelsFor(labels: readonly Label[], gameId: string): Label[] {
  return labels.filter((l) => l.game_id === gameId || l.game_id === null);
}

export function useCreateLabel() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (label: { name: string; game_id: string | null }) => {
      const { data, error } = await supabase().from('labels').insert(label).select().single();
      if (error) throw error;
      return data;
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: queryKeys.labels }),
  });
}
